import Axios from '@/api/http'

/**
 * 服务端标签选择
 * */
export function getapipacedepttiplist(query) {
  return Axios({
    method: 'post',
    url: '/api/getspacedepttiplist',
    data: query
  })
}

/**
 * 获取当前用户同级部门
 * */
export function getequalorglist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getequalorglist',
    data: query
  })
}

/**
 * 客户端组织选择
 * */
export function getopenorganizationlist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getorganizationlist',
    data: query
  })
}

/**
 * 服务端组织选择
 * */
export function getapiorganizationlist(query) {
  return Axios({
    method: 'post',
    url: '/api/getorganizationlist',
    data: query
  })
}
/**
 * 客户端角色选择
 * */
export function getopenrolelist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getrolelist',
    data: query
  })
}

/**
 * 服务端角色选择
 * */
export function getapirolelist(query) {
  return Axios({
    method: 'post',
    url: '/api/getrolelist',
    data: query
  })
}
/**
 * 客户端用户选择
 * */
export function getopenuserlist(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserlist',
    data: query
  })
}

/**
 * 服务端用户选择
 * */
export function getapiuserlist(query) {
  return Axios({
    method: 'post',
    url: '/api/getuserlist',
    data: query
  })
}

/**
 * 获取客户端用户信息
 * */
export function getopenuserbyid(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserbyid',
    data: query
  })
}

/**
 * 获取服务端用户信息
 * */
export function getapiuserbyid(query) {
  return Axios({
    method: 'post',
    url: '/api/getuserbyid',
    data: query
  })
}

/**
 * 获取用户信息
 * */
export function getuserbindmsg(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserbindmsg',
    data: query
  })
}

/**
 * 批量获取用户信息
 * */
export function getuserbindlistmsg(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getuserbindlistmsg',
    data: query
  })
}

/**
 * 获取用户信息
 * */
export function getnewuserbindmsg(query) {
  return Axios({
    method: 'post',
    url: '/openapi/getnewuserbindmsg',
    data: query
  })
}

/**
 * 获取用户的真实手机
 * */
export function getusersensitivedata(date) {
  return Axios({
    method: 'post',
    url: 'openapi/getusersensitivedata',
    data: date,
    // responseType: "arraybuffer"
  })
}

